import React from 'react';
import { Badge } from '../ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqItems } from '../../data/mock';

export const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <Badge className="mb-6 bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100">
            FAQ
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-slate-600">
            Encontre respostas para as dúvidas mais comuns sobre os nossos serviços.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-xl border border-slate-200 px-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-teal-600 hover:no-underline py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 pb-5 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
